import { useList } from '../../../api/react-query';
import { useApp } from '../../../context';

export function useListWeekOffs({ departmentId, textFilter, weekOffIds }) {
  const { rowsPerPage } = useApp();

  const { data, isLoading, isRefetching, isFetching, refetch } = useList(
    'getEmployeeWeekOff',
    {
      searchName: textFilter,
      isDept: departmentId,
      rowsPerPage,
      weekOffIds,
    },
  );

  return {
    data: data?.data?.data?.data || [],
    count: data?.data?.data?.total_count,
    isLoading: isLoading || isRefetching || isFetching,
    refetch,
  };
}
